import React from 'react';
import './projects.css'; // Create and link to the CSS for styling
import liontours from '../assets/image4.jpeg'
import iotdevice from '../assets/image5.jpg';
import fitx from '../assets/image6.png';
import limit from '../assets/image8.png'
import cannycube from '../assets/image9.png';
import hotelr from '../assets/image10.png';
import chatbot from '../assets/image11.png';
import exam from '../assets/image12.png';
import rescueme from '../assets/image13.jpg';
import gurugedara from '../assets/image14.jpeg';
import zuma from '../assets/image15.png';

const projectsData = [
  {
    title: 'Virtual Dressing Room Web Application (LIMIT)',
    description: 'Developed  a system that allows users to create a wishlist, display detailed clothing information, add items to the cart,write reviews, and handle payment processes..',
    img: limit,
    tools: ['React', 'EXpessJS', 'MongoDB', 'NodeJs','Bootstrap','Figma','Mockflow']
  },
  {
    title: 'Social fitness app (FitX) Web Application',
    description: 'Create workout planning app by implementing features forcreating personalized workout plans and tracking userprogress, allowing users to update and share their workoutstatuses within the social community.',
    img: fitx,
    tools: ['React', 'SpringBoot', 'Figma', 'TailwindCss']
  },
  {
    title: 'Online Tour Management System (Lion Tours) ',
    description: ' Managing payments for employees, tracking expenses,income, and implementing all payment-related factors,ensuring seamless financial operations within the platform in a seperate dashboard with all calculations',
    img: liontours,
    tools: ['MongoDb','Raect','ExpressJs','Nodejs', 'Bootstrap', 'Figma']
  },
  {
    title: 'IoT Wearable Device for Fall Detection when rehabilation ',
    description: 'Created a wearable IoT device for monitoring patients with walking disabilities during rehabilitation. It sense patients heart rate and oxygen level and patten of walking' ,
    img: iotdevice,
    tools: ['C++', 'Arduino', 'React', 'MQTT','Node-Red']
  },
  {
    title: 'Company Finance Management App ',
    description: 'Expense management included  categorization of expenses, and financial summaries. The app now provides users with quick access to detailed insights, supporting better budgeting and resource allocation. This enhancement simplifies financial management, ensuring accurate records and accountability. Overall, it aids in optimizing spending and sustainable financial practices',
    img: cannycube,
    tools: [ 'Kotlin', 'Android Studio', 'SQLitte','Figma','Mockflow']
  },
  {
    title: 'Examination Management System',
    description: 'The student online examination management system streamlines student data management by allowing users to add, view, edit, and delete student details. This functionality ensures accurate, up-to-date records, making it easier for administrators to maintain organized, accessible student data. With efficient profile management, the system reduces manual work, minimizes errors, and supports a seamless experience for all users.',
    img: exam,
    tools: ['HTML', 'CSS', 'JAVA', 'MYSQL','Figma']
  },
  {
    title: 'Hotel Room Reservation System ',
    description: 'A web application that allows users to reserve hostel rooms online, providing staff management features and a review section. In this prohectM my contribution involved developing the staff management module and enabling reviews, making it easy to manage staff information and update guest feedback efficiently within the platform use of CRUD operations correctly' ,
    img: hotelr,
    tools: ['HTML', 'CSS', 'Java Script','', 'SQL','PHP','Balsamiq','','Figma']
  },
  {
    title: 'Sinhala Language Speaking Assistant API (Still Working on this project)',
    description: 'This API is designed to support a voice-based Sinhala language assistant. It enables natural Sinhala conversation, recognizing and processing Sinhala language inputs, and responding with voice outputs.',
    img: chatbot,
    tools: ['Python', 'Flask','Django','Firebase','Node.js with Express','','Docker','MySQL']
  },
  {
    title: 'ZUMA Online Buying & Selling Book Store  ',
    description : 'This website provides users with essential functionalities for browsing, searching, and purchasing books. Allows easy navigation through various book categories and featured collections. Implemented earch functionality with filtering options for users to quickly find specific titles or authors. Additionally, the checkout process is enhance the buying experience, ultimately increasing user satisfaction. ',
    img: zuma,
    tools: ['HTML', 'CSS', 'JAVA', 'MYSQL', 'PHP','', 'Figma']
  },
  {
    title: 'RescueMe.org Web Application Redesign (HCI)',
    description: 'Led the redesign of the RescueMe.com website, enhancing user experience according HCI standards. Conducting user research to identify main points and areas for improvement. Using Figma, implemented UI/UX design for improving usability and accessibility. While designing the ptojrct focused on handling  color theory and uses of correct typography and iconography theories by using our user reasearch about this site ',
    img: rescueme,
    tools: ['Figma', 'Mockflow', ]
  },
  {
    title: 'Guru Gedara Sinhala App (Still working on this project)',
    description: 'This app makes learning more accessible, empowering children to overcome challenges and thrive academically . This project aspires to bridge educational gaps and provide valuable support to dislexic and dyscalculic grade 1-5 primary learners. The initiative ultimately underscores the role of technology in driving positive, impactful change in education.',
    img: gurugedara,
    tools: ['Flutter', 'Dart', 'MongoDB', 'Machine Learning Algorithms','Figma']
  },

  
];

const Projects = () => {
  return (
    <div className="projects-container">
      <div className="projects-grid">
        {projectsData.map((project, index) => (
          <div key={index} className="project-card">
            <img src={project.img} alt={`${project.title} thumbnail`} className="project-image" />
            <h3>{project.title}</h3>
            <p>{project.description}</p>
            <div className="project-tools">
              <h4>Tools & Technologies:</h4>
              <ul>
                {project.tools.map((tool, i) => (
                  <li key={i}>{tool}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;
